import { AxiosError } from "axios";

export interface BaseErrorResponse {
  code?: string;
  // You can add other common properties here if needed
}

const baseUnauthorizedCodes = ["no-permission-to-view-app", "is-not-admin", "(SSO) undefined", "You have been denied permission"];
const ssoSessionError = ["Cant connect to SSO service"];

// Determines whether the user should be redirected to the unauthorized page
export const shouldRedirect = (error: AxiosError<any, any>, unauthorizedCodes = baseUnauthorizedCodes) => {
  // console.log("[Should Redirect] Error ::  ", error);
  if (!error.response || !error.response.data) {
    return false;
  }
  // Check for a 401 error and an unauthorized code in the list of unauthorized codes
  let shouldRedirectToUnauthorized = error.response.status === 401 && unauthorizedCodes.includes(error.response?.data?.message);
  // Check for a 403 error and an unauthorized code in the list of unauthorized codes
  shouldRedirectToUnauthorized =
    shouldRedirectToUnauthorized || (error.response.status === 403 && unauthorizedCodes.includes(error.response?.data?.message));

  if (shouldRedirectToUnauthorized) {
    // Redirect to the unauthorized page
    window.location.pathname = "/unauthorized";
  }

  // Case : SSO Session data error 400
  let sessionDataError =
    "statusCode" in error.response.data &&
    error.response.data.statusCode === 400 &&
    "message" in error.response.data &&
    ssoSessionError.includes(error.response.data.message as string);
  if (sessionDataError) {
    shouldRedirectToUnauthorized = true;
    window.location.href = `${process.env.REACT_APP_LOGIN_PAGE}/${process.env.REACT_APP_ID}`;
  }

  return shouldRedirectToUnauthorized;
};
